import { render, staticRenderFns } from "./ReviewsPopup.vue?vue&type=template&id=5af50497&"
import script from "./ReviewsPopup.vue?vue&type=script&lang=js&"
export * from "./ReviewsPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports